<template>
  <div >
    <div class="d-flex flex-column" style="height:100%;background:#f7f7f7" id="page2">
      <div class="d-flex align-items-center" style="height:80px;padding-left:6%;padding-right:9%" id="header">
      	<div class="d-flex align-items-center justify-content-between width-p100" style="height:80px" >
      		<a href="#"  class="d-flex align-items-center">
      			<img src="https://image.xingqubaike.com:8443/minicard/ucenter/personcenter/login/logo.png" style="width:40px;height:40px" >
      			<div class="mar-left10 fz26 font-weight-bold">橙贝商城</div>
      		</a>
          <i class="el-icon-s-fold fz30 header-more c-fe9120" v-on:click="openMore()"></i>
      		<div class="top-nav d-flex align-items-center aaa" style="height:80px">
      			<a href="javascript:void(0)" v-on:click="goBack('git')" class="nav_a">礼物兑换</a>
      			<a href="javascript:void(0)" v-on:click="goBack('vip')" class="nav_a">会员专享</a>
      			<a href="javascript:void(0)" v-on:click="goBack('group')" class="nav_a">团购活动</a>
      			<a href="javascript:void(0)" v-on:click="goBack('boutique')" class="nav_a">精品圈子</a>
      			<a href="javascript:void(0)" v-on:click="goBack('hotGoods')" class="nav_a">热卖宝贝</a>
      			<a href="javascript:void(0)" v-on:click="goBack('fxCircle')" class="nav_a">分销圈子</a>
      			<a href="javascript:void(0)" v-on:click="goBack('fxGoods')" class="nav_a">分销宝贝</a>
      			<a href="javascript:void(0)" v-on:click="goBack('store')" class="nav_a">精选店铺</a>
      		</div>
      	</div>
      </div>

      <el-drawer
        title="橙贝商城"
        custom-class="more"
        :visible.sync="drawer"
        :with-header="false">
        <a href="#"  class="d-flex align-items-center" style="margin: 30px auto;width: 160px;margin-top: 50px;">
        	<img src="https://image.xingqubaike.com:8443/minicard/ucenter/personcenter/login/logo.png" style="width:40px;height:40px" >
        	<div class="mar-left10 fz22 font-weight-bold c-000000">橙贝商城</div>
        </a>
        <div style="width: 100%;font-size: 20px;text-align: center;margin-top: 30px;" v-on:click="goBack('git')">礼物兑换</div>
        <div style="width: 100%;font-size: 20px;text-align: center;margin-top: 30px;" v-on:click="goBack('vip')">会员专享</div>
        <div style="width: 100%;font-size: 20px;text-align: center;margin-top: 30px;" v-on:click="goBack('group')">团购活动</div>
        <div style="width: 100%;font-size: 20px;text-align: center;margin-top: 30px;" v-on:click="goBack('boutique')">精品圈子</div>
        <div style="width: 100%;font-size: 20px;text-align: center;margin-top: 30px;" v-on:click="goBack('hotGoods')">热卖宝贝</div>
        <div style="width: 100%;font-size: 20px;text-align: center;margin-top: 30px;" v-on:click="goBack('fxCircle')">分销圈子</div>
        <div style="width: 100%;font-size: 20px;text-align: center;margin-top: 30px;" v-on:click="goBack('fxGoods')">分销宝贝</div>
        <div style="width: 100%;font-size: 20px;text-align: center;margin-top: 30px;" v-on:click="goBack('store')">精选店铺</div>
      </el-drawer>


      <div style="width:210px;background:#fff;position: fixed;top: 300px;right: 50px" class="d-flex align-items-center justify-content-center flex-column pad-left5 pad-right5 pad-top10 pad-bottom10 qrcodes">
        <div ref="qrCodeUrl"></div>
        <div class="fz14 c-333333 mar-top5">请扫码前往小程序购买宝贝</div>
        <div class="c-999999 mar-top10" style="font-size:10px">兴趣百科-再小的兴趣也是同好</div>
      </div>
    	<div class="d-flex justify-content-center mar-top100">
        <!-- 日记详情左边部分 -->
        <div class="content-left bgc-ffffff align-self-start pad-bottom30">
          <div class="detail">
            <!-- 海报图 -->
            <div class="diary-image mar-top20">
                <img :src="diaryInfo.theme.poster" class="poster" />
            </div>

            <!-- 名称 -->
            <div class="diary-txt fz14 mar-top20 pad-bottom10 border-bottom-e7e7e7">{{diaryInfo.theme.title}}</div>

            <!-- 类型 -->
            <!-- <div class="diary-txt fz14 mar-top20 pad-bottom10">
                <span style="float: right">实物宝贝</span>
            </div> -->

            <div style="background:#f1f1f1;width:400px;margin:10px auto;padding:10px 20px 10px 10px;border-radius: 6px;" class="d-flex align-items-center">
                <img :src="diaryInfo.circle.poster" style="width:60px;height:60px;border-radius: 3px;object-fit: cover"/>
                <div class="mar-left15 flex-fill">
                    <div class="fz16 font-weight-bold">{{diaryInfo.circle.title}}</div>
                    <div class="mar-top10">{{diaryInfo.circle.diaryCount}}篇日记 | {{diaryInfo.circle.joinCount}}人参与</div>
                </div>
            </div>

            <!-- 描述 -->
            <div class="diary-tag mar-top20">
              <div class="fz18 c-000000 bgc-b9b9b9">详情描述</div>
              <div v-for="item in diaryInfo.dataInfoList" :key="index">
                <!-- 文字 -->
                <div class="diary-txt mar-top20 fz16" v-if="item.type == 1">
                    <pre>{{item.value}}</pre>
                </div>

                <!-- 图片 -->
                <div class="diary-image mar-top20" v-if="item.type == 2">
                    <div v-for="xitem in item.themeImageList">
                        <img :src="xitem.ip+xitem.path" style="height: auto;width: 100%" v-on:click="openImg(xitem.ip+xitem.path)"/>
                    </div>
                </div>

                <!-- 音频 -->
                <div class="diary-audio mar-top20" v-if="item.type == 3">
                    <div class="fz16 c-000000 bgc-f1f3f4 pad-left10" style="padding-bottom: 30px;margin-bottom: -30px;padding-top: 10px;">{{item.title}}</div>
                    <audio style="width: 450px;" :src="item.ip + item.path" controls="controls"></audio>
                </div>

                <!-- 视频 -->
                <div class="diary-image mar-top20" v-if="item.type == 4">
                    <video width="450px" height="450px" controls="controls">
                        <source :src="item.ip+item.path" type="video/mp4" />
                    </video>
                </div>

                <!-- 公众号链接或文件 -->
                <div class='desc_href' v-on:click="openNewWin(item.ip + item.value)" v-if="item.type == 5">
                    <input v-model="item.ip + item.value" type="hidden" id="link" v-if="item.linkType == 1"/>
                    <input v-model="item.ip + item.value" type="hidden" id="file" v-if="item.linkType == 2"/>
                    <div class='icon'></div>
                    <div class='text'>{{item.title}}</div>
                </div>

                <!-- 位置 -->
                <div class='desc_add_location_view' v-if="item.type == 6">
                    <img class='add_location_image' src='https://image.xingqubaike.com:8443/minicard/home/09dingweitupian.png'></image>
                    <div class='add_location_text'>{{item.value}}</div>
                </div>
              </div>
            </div>

          </div>


         <!-- <div style="margin-top: 80px;">
            <div style="margin:0 30px;border-bottom:1px solid #c1c1c1;padding:20px 0" class="fz16">{{diary.secondTitle}}</div>
            <div style="background:#f1f1f1;width:510px;margin:30px auto;padding:10px 20px 10px 10px;border-radius: 6px;" class="d-flex align-items-center">
              <img :src="diary.circleImg" style="width:60px;height:60px;border-radius: 3px;" class="imgFit"/>
              <div class="mar-left15 flex-fill">
                <div class="fz16 font-weight-bold">{{diary.circleTile}}</div>
                <div class="mar-top10">{{diary.clockNum}}篇日记&nbsp;{{diary.joinNum}}人参与</div>
              </div>
              <div style="height:40px;width:90px;text-align: center;line-height: 40px;font-size:15px;border-radius:6px;background:#ff9a2e" class="c-ffffff" v-on:click="lookMore(layerShow)">点击参加</div>
            </div>
          </div> -->
        </div>

        <!-- 右边部分 -->
        <div class="content-right mar-left35 bgc-ffffff align-self-start rightContent" style="width:350px;">
          <div style="height:10px;background:#f7f7f7" ></div>
          <div style="height:550px;overflow-y: scroll;"  >
             <div class="mar-left15 pad-top20 mar-right15 fz16 font-weight-bold" style="border-bottom:1px solid #c1c1c1 fz16 font-weight-bold">热门推荐</div>
             <div class="d-flex align-items-center pad-left15 pad-right15 mar-top20 mar-bottom15" v-for="item in list" v-on:click="toDetail(item.id)">
               <img :src="item.url" class="imgFit" style="width:65px;height:65px;border-radius: 5px;"/>
               <div class="mar-left10">
                 <div class="twoLine">{{item.title}}</div>
               </div>
             </div>
          </div>
        </div>
      </div>
      <div style="height:80px"></div>
      <v-footer></v-footer>
    </div>

    <div style="width:100%;height:100%;position: fixed;top:0;left:0;z-index:10;background:rgba(0,0,0,0.5)" v-if="layerShow" class="d-flex flex-column align-items-center justify-content-center">
        <div style="width:210px;background:#fff" class="d-flex align-items-center justify-content-center flex-column pad-left5 pad-right5 pad-top10 pad-bottom10">
          <img src="../../assets/img/index/miniProjectImg.jpg" style="width:200px;height:200px;" />
          <div class="fz14 c-333333 mar-top5">请扫码前往小程序操作</div>
          <div class="c-999999 mar-top10" style="font-size:10px">兴趣百科-再小的兴趣也是同好</div>
        </div>
        <img src="../../assets/img/index/close.png" style="width:25px;height:25px;margin-top:25px" v-on:click="lookMore(layerShow)"/>
      </div>
    </div>
  </div>

</template>

<script>
import axios from "axios";
import header from '@/pages/pc/header';
import footer from '@/pages/pc/footer';
import qRCode1 from "qrcodejs2";
export default {
  name: 'pcIndex',
  components:{
    'v-header':header,
    'v-footer':footer,
  },
  data () {
    return {
      diaryInfo:{},
      list: [],
      layerShow:false,
      drawer: false
    }
  },
  mounted(){//页面加载后，调用接口数据
    var _this = this;
    this.getData(0);
    this.getGoods();
    setTimeout(function() {_this.creatQrCode();}, 1000);
  },
  methods:{
      lookMore:function(param){//点击查看更多方法
        this.layerShow=!param
      },

      openMore: function(){
        this.drawer=true
      },

      //获取数据列表
      getData:function(id){
        var data = {}
        data.themeid = this.$route.params.id
        axios.post('https://www.xingqubaike.com/wx/handshake-provider-xswl-interest/theme/getThemeInfo',data).then(response => {
          console.log(response)
            this.diaryInfo=response.data.result.json
        }, response => {
            console.log("error");
        });
      },

      //获取数据列表
      getGoods:function(){
        var data = {}
        axios.post('https://www.xingqubaike.com/wx/handshake-provider-xswl-home/home/official/getGoodsListForH5',data).then(response => {
            this.list=response.data.result.list
        }, response => {
            console.log("error");
        });
      },

      toDetail:function(id){
        //this.$router.push({ name: 'diaryDetail',params:{id:id}})
        this.getData(id)
      },

      //打开链接
      openNewWin:function(url){
        window.open(url);
      },

      creatQrCode() {
        var id = this.$route.params.id;
        var openid = this.$route.params.openid;
        var qrcode = new qRCode1(this.$refs.qrCodeUrl, {
            text: 'https://www.xingqubaike.com/ewm/&1&9&'+id + "&1&"+openid, // 需要转换为二维码的内容
            width: 200,
            height: 200,
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: qRCode1.CorrectLevel.H
        })
      },

      goBack:function(type){
        this.$router.push({ name: 'shop',params:{type:type}})
      },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="less" scoped>
  @import "../../../static/css/firstPage.css"; //直接在需要对应的vue中使用es6进行引入
  .titlePad{padding:0 20px;margin:15px 0}
  #header{background:#FFFFFF;position: fixed;top: 0;width: 85%;z-index: 9;}
  #header a{color:#333333}
  .nav_a{height:100%;display: flex;align-items: center}
  .more{width: 50vw !important;}
  .diary-bottom{
      width: 600px;
      height: auto;
      margin-left: auto;
      margin-right: auto;
      padding-bottom: 100px;
      margin-top: 20px;
  }

  .diary-txt{
      width: 600px;
      height: auto;
      margin-left: auto;
      margin-right: auto;
      line-height: 24px;
      font-size: 14px;
      color: #333;
  }

  pre {
      white-space: pre-wrap;
      word-wrap: break-word;
  }

  .diary-audio{
      width: 600px;
      height: auto;
      margin-left: auto;
      margin-right: auto;
  }


  .diary-image{
      width: 600px;
      height: auto;
      margin-left: auto;
      margin-right: auto;
  }

  .desc_href{
      height: 32px;
      width: 600px;
      margin-left: auto;
      margin-right: auto;
      border: 2px solid #8fc4f9;
      margin-top: 26px;
  }

  .desc_href .icon{
      float: left;
      background-image: url(https://image.xingqubaike.com:8443/minicard/ucenter/personcenter/editdetails/circleinteraction/18-00lianjie.png);
      background-repeat: no-repeat;
      background-size: 18px 19px;
      background-position-y: center;
      background-position-x: 8px;
      width: 32px;
      height: 32px;
      border-right: 2px solid #8fc4f9;
  }

  .desc_href .text{
      float: left;
      color: #8fc4f9;
      font-size: 14px;
      height: 32px;
      line-height: 32px;
      padding-left: 10px;
      width: 550px;
      overflow:hidden;
      text-overflow:ellipsis;
      white-space:nowrap;
  }

  .desc_add_location_view{
      border: 2px solid #e1e1e1;
      height: 32px;
      line-height: 32px;
      width: 600px;
      margin: 26px auto 10px auto;
  }

  .desc_add_location_view .add_location_image{
      width: 32px;
      height: 32px;
      float: left;
  }

  .desc_add_location_view .add_location_image image{
      width: 32px;
      height: 32px;
  }

  .desc_add_location_view .add_location_text{
      float: left;
      margin-left: 5px;
      color: #858179;
      font-size: 14px;
      letter-spacing: 1px;
  }

  .diary-tag{
      width: 600px;
      height: auto;
      margin-left: auto;
      margin-right: auto;
  }


  .poster{
      width: 600px;
      height: 200px;
  }

  @media screen and (max-device-width:900px){
   .rightContent{
     display: none;
   }
   .qrcodes{
     display: none !important;
   }
  }

  @media screen and (max-width:900px){
   .rightContent{
     display: none;
   }
   .qrcodes{
     display: none !important;
   }
  }
  @media screen and (min-width:1430px){
      .header-more{display: none;}
  }
  @media screen and (max-width:1430px){
      .aaa{display: none !important;}
  }
</style>



// WEBPACK FOOTER //
// src/pages/pc/goodsDetail.vue